import { createSlice } from "@reduxjs/toolkit";
import {     list_stateCityThunk } from "./thunk";

export const initialState = {
  listStateCityData: [],
  listStateCityError: '', // for error message
  listStateCityLoading: false,
  
  
};

const List_State_City = createSlice({
  name: "List_State_City",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(list_stateCityThunk.pending, (state) => {
      state.listStateCityLoading = true ;
      state.listStateCityData= [];
      state.listStateCityError='';

  });
    builder.addCase(list_stateCityThunk.fulfilled, (state, action) => {
        state.listStateCityData = action.payload.data;
        state.listStateCityLoading = false ;
    });
    builder.addCase(list_stateCityThunk.rejected, (state, action) => {
      state.listStateCityError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.listStateCityLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = List_State_City.actions

export default List_State_City.reducer;